export default __webpack_public_path__ + "static/media/MissionControl-100k.916e34e3.png";